export default __webpack_public_path__ + "static/char-thumb-sp02-53a494e7610c2fcc8c61c0564f27fc86.png";